import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { useSendStore } from '@/store/useSendStore'
import useOffsets from '@/hooks/useOffsets'

interface RecipientData {
  id: string
  name: string
  username?: string
  avatar?: string
  type: 'send' | 'request'
}

interface SendWithUserActionButtonsProps {
  recipientData: RecipientData
}

export const SendWithUserActionButtons: React.FC<
  SendWithUserActionButtonsProps
> = ({ recipientData }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  const cryptoAmount = useSendStore((state) => state.cryptoAmount)
  const fiatAmount = useSendStore((state) => state.fiatAmount)
  const isFiatMode = useSendStore((state) => state.isFiatMode)
  const selectedCurrency = useSendStore((state) => state.selectedCurrency)
  const shakeComponent = useSendStore((state) => state.shakeComponent)

  const handleContinue = () => {
    const currentAmount = isFiatMode ? fiatAmount.amount : cryptoAmount.amount

    // Check that amount is entered
    if (!currentAmount || currentAmount === '0') {
      shakeComponent()
      return
    }

    // Build data in RecipientParams format for confirmation page
    const recipientParams = {
      id: recipientData.id,
      name: recipientData.name,
      username: recipientData.username,
      avatar: recipientData.avatar,
      type: recipientData.type,
      currencyValue: cryptoAmount.amount,
      currencyCode: cryptoAmount.code,
      fiatValue: fiatAmount.amount,
      fiatCode: fiatAmount.code,
      byApp: 'true', // Flag indicating we came from the app
    }

    // Navigate to confirmation page with recipient data
    navigate('/send-request/confirm', {
      state: recipientParams,
    })
  }

  return (
    <BaseView
      className="fixed bottom-0 left-0 right-0 p-4 z-20"
      style={{
        paddingBottom: `${offsets.bottom}px`,
      }}
    >
      <AppButton
        type="blur"
        onPress={handleContinue}
        label={
          recipientData.type === 'send'
            ? t('form:actions.continue')
            : t('form:actions.continue')
        }
        className="w-full"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: 'white',
          minHeight: '48px',
        }}
      />
    </BaseView>
  )
}
